import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHero from "@/components/PageHero";
import { T } from "@/constants/testIds";

export default function BibleStudiesIndex() {
  const [items, setItems] = useState([]);
  const [testament, setTestament] = useState(null);

  useEffect(() => {
    const url = testament ? `/bible-studies?testament=${testament}` : "/bible-studies";
    api.get(url).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [testament]);

  return (
    <>
      <PageHero
        eyebrow="Bible Studies"
        title="Study the Scriptures, carefully."
        subtitle="Book, chapter, verse, topical, and character studies — with reflection and application. Read slowly. Read for keeps."
      />
      <section className="py-16 sm:py-24">
        <div className="container-editorial">
          <div className="flex gap-2 mb-10">
            {[
              { l: "All", v: null },
              { l: "Old Testament", v: "old" },
              { l: "New Testament", v: "new" },
            ].map((f) => (
              <button
                key={f.l}
                data-testid={`studies-filter-${f.v || "all"}`}
                onClick={() => setTestament(f.v)}
                className={`px-4 py-2 text-xs uppercase tracking-widest border transition-colors ${
                  testament === f.v
                    ? "bg-ink text-background border-ink"
                    : "border-border text-ink-muted hover:border-ink hover:text-ink"
                }`}
              >
                {f.l}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {items.map((s) => (
              <Link
                key={s.id}
                to={`/bible-studies/${s.slug}`}
                data-testid={T.studyCard(s.slug)}
                className="group paper-card p-8 hover:border-ink transition-colors flex flex-col"
              >
                <span className="eyebrow text-forest">
                  {s.testament === "old" ? "Old Testament" : "New Testament"} · {s.study_type}
                </span>
                <h3 className="heading-3 mt-3 group-hover:text-forest transition-colors">{s.title}</h3>
                <p className="body-copy mt-3 text-ink-muted">{s.summary}</p>
                <span className="mt-6 text-xs uppercase tracking-widest text-ink">Read study →</span>
              </Link>
            ))}
            {items.length === 0 && <p className="text-ink-muted">No studies yet.</p>}
          </div>
        </div>
      </section>
    </>
  );
}
